<template>
  <component
    :is="`step-${step}`"
    :step="step"
    :box_init="box"
    :box.sync="current_value"
    :current_tab="current_tab"
    :list_of_contact_methods="list_of_contact_methods"
    :list_of_groups="list_of_groups"
    v-on="$listeners"
    @change-step="change_step"
    @update-groups="update_groups"
    @update-methods="update_methods"
  />
</template>

<script>
  import StepInit from './steps/init';
  import StepAddMethod from './steps/add-method';
  import StepAddGroup from './steps/add-group';
  import { BaseMixin } from '../_base/_base-mixin';
  import { GroupService } from '@pbx/services/GroupService';
  import { ContactMethodService } from '@pbx/services/ContactMethodService';

  /**
   * Из схемы передается параметр box - текущее состояние бокса и его параметров на схеме
   * При переходе по шагам мы должны сохранять введенные значения,
   * но не обновлять инфу на схеме до нажатия кнопки "сохранить" на шаге Init.
   * По этому box копируется в current_value в BaseMixin.
   * .sync - аналог v-model только для кастомных названий
   */

  export default {
    components: {
      StepInit,
      StepAddMethod,
      StepAddGroup
    },

    mixins: [BaseMixin],

    data() {
      return {
        list_of_contact_methods: [],
        list_of_groups: [],
        current_tab: 'contact_methods'
      };
    },

    created() {
      this.update_groups();
      this.update_methods();
    },

    methods: {
      update_groups: function() {
        GroupService.getSelect().then(items => (this.list_of_groups = items));
      },

      update_methods: function() {
        ContactMethodService.getSelect().then(items => (this.list_of_contact_methods = items));
      },

      change_step: function({ step, params }) {
        this.step = step;
        if (params.tab) {
          this.current_tab = params.tab;
        }
      }
    }
  };
</script>
